import './styles.scss'

import React from 'react'

export default function MobilePopularCities ({ cities }) {
  return (
    <>
      {cities && (
        <div className='grid'>
          <div className='col-1-1 buckets'>
            <ul>
              {cities.map(bucket => (
                <li key={bucket.url}>
                  <a href={bucket.url} title={bucket.title}>
                    {bucket.city_with_country_code}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  )
}
